import { Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { catchError, exhaustMap, filter, map, withLatestFrom } from 'rxjs/operators';

import { IAuroraState } from '@apps/aurora.state';
import { DepartmentsMiscDomainService } from '@apps/its2/domain/departments-misc-domain.service';

import * as fromDepartmentsActions from './departments.actions';
import { getRootDepartmentsLoadedStatus } from '../root.reducer';

@Injectable()
export class RootDepartmentsEffects
{
    constructor (
        private actions: Actions,
        private store: Store<IAuroraState>,
        private departmentsService: DepartmentsMiscDomainService
    )
    { }

    rootDepartmentsRequested = createEffect(
        () =>
            this.actions
                .pipe(
                    ofType(fromDepartmentsActions.RootDepartmentsRequested),
                    withLatestFrom(this.store.select(getRootDepartmentsLoadedStatus)),
                    filter(([, isLoaded]) => !isLoaded),
                    exhaustMap(() =>
                        this.departmentsService.getDepartments()
                            .pipe(
                                map((departments) =>
                                    fromDepartmentsActions.RootDepartmentsSucceeded({ departments })
                                ),
                                catchError(() =>
                                    of(fromDepartmentsActions.RootDepartmentsFailed())
                                )
                            )
                    )
                )
    );
}
